import * as HOTEL_PROPERTY_URL from "store/constants/hotel";
import * as DESTINATION_IN_BLOCKS from "store/constants/destinationInBlocks";
const HOTELS = {
  [HOTEL_PROPERTY_URL.AYANA_RESORT_AND_SPA]: "/bali/ayana-resort-and-spa",
  [HOTEL_PROPERTY_URL.RIMBA_JIMBARAN_BALI]: "/bali/rimba-jimbaran",
  [HOTEL_PROPERTY_URL.VILLAS_AYANA_RESORT_BALI]: "/bali/the-villas-at-ayana",
  [HOTEL_PROPERTY_URL.AYANA_SEGARA_BALI]: "/bali/ayana-segara",
  [HOTEL_PROPERTY_URL.AYANA_KOMODO]: "/labuan-bajo/komodo",
  [HOTEL_PROPERTY_URL.AYANA_LAKODIA]: "/labuan-bajo/lakodia",
  [HOTEL_PROPERTY_URL.AYANA_BALI]: "https://www.ayana.com/bali/",
  [HOTEL_PROPERTY_URL.JAKARTA_LOCATION]: "/jakarta/ayana-midplaza-jakarta",
  [DESTINATION_IN_BLOCKS.BALI]: "https://www.ayana.com/bali/",
  [DESTINATION_IN_BLOCKS.JAKARTA]: "/jakarta/ayana-midplaza-jakarta",
};

export default HOTELS;
